import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';
import { ChannelType } from 'models/ChannelType';
import { CustomerMasterSourceType } from 'models/swagger/customerMasterSourceType';

export const api = {
  OTPSendSms: (url: string): Promise<ExtendedAxiosResponse> => {
    return apiClient.post(
      `${url}/otp/send-sms`,
      {},
      {
        params: {
          channel: ChannelType.MO2_CARE,
          customerMasterSource: CustomerMasterSourceType.O2POP,
        },
      }
    );
  },

  OTPVerify: (url: string, otpCode: string): Promise<ExtendedAxiosResponse> => {
    return apiClient.get(`${url}/otp/verify`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        otpCode: otpCode,
      },
    });
  },
};
